import { Checkbox } from "@capacit-com/lara-law-shared-ui";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@capacit-com/lara-law-shared-ui";
import { TenantRole } from "@/models/tenant/tenant";

type RolesPickerProps = {
  roles: TenantRole[];
  selected: TenantRole[];
  onChange: (next: TenantRole[]) => void;
  idPrefix?: string;
  className?: string;
  maxHeight?: string;
};

export function RolesPicker({
  roles,
  selected,
  onChange,
  idPrefix = "role",
  className = "",
  maxHeight = "max-h-60",
}: RolesPickerProps) {
  const selectedNames = new Set(selected.map((s) => s.externalName));

  const handleToggle = (name: string, checked: boolean | "indeterminate") => {
    const isChecked = checked === true;
    onChange(
      isChecked
        ? [...selected, roles.find((r) => r.externalName === name)!]
        : selected.filter((r) => r.externalName !== name)
    );
  };
  const isSystemRole = (role: TenantRole) => {
    return role.externalName.toLowerCase().includes("system");
  };
  return (
    <TooltipProvider>
      <div className="space-y-4">
        <div>
          <label className="text-sm font-medium mb-2 block">
            Tilgængelige roller
          </label>
          <div className={`space-y-2 overflow-auto ${maxHeight} ${className}`}>
            {roles.map((r) => {
              const id = `${idPrefix}-${r.externalName}`;
              const isChecked = selectedNames.has(r.externalName);
              const isDisabled = isSystemRole(r);

              const content = (
                <div className="flex items-center space-x-2">
                  <Checkbox
                    id={id}
                    checked={isChecked}
                    onCheckedChange={(checked) =>
                      handleToggle(r.externalName, checked)
                    }
                    disabled={isDisabled}
                  />
                  <label
                    htmlFor={id}
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                  >
                    {r.displayName}
                  </label>
                </div>
              );

              if (isDisabled && isSystemRole(r)) {
                return (
                  <Tooltip key={r.externalName}>
                    <TooltipTrigger asChild>{content}</TooltipTrigger>
                    <TooltipContent side="left">
                      <p>Systemroller kan ikke tildeles manuelt</p>
                    </TooltipContent>
                  </Tooltip>
                );
              }

              return <div key={r.externalName}>{content}</div>;
            })}
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
}
